import { SearchScopeKind } from 'owa-search-service/lib/data/schema/SearchScope';
import { getStore } from '../store/store';

export default function getIsAggregateMailboxScopeSelected(): boolean {
    const scopeKind = getStore().staticSearchScope?.kind;
    return scopeKind === SearchScopeKind.AllMailboxes || scopeKind === SearchScopeKind.AllPstFiles;
}
